import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import { Login, ForcePasswordChange, Forgot, Reset } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Advisor from "@/pages/Advisor";
import UseCases from "@/pages/UseCases";
import Sandbox from "@/pages/Sandbox";
import Maturity from "@/pages/Maturity";
import BusinessValue from "@/pages/BusinessValue";
import Users from "@/pages/Users";
import Faq from "@/pages/Faq";
import Reports from "@/pages/Reports";
import Governance from "@/pages/Governance";
import Aioc from "@/pages/Aioc";
import { Security, RedTeam, Risk, Compliance, Audit, Soc, Integrations, Agents, Models, SystemAdmin } from "@/pages/Modules";

function Protected({ children }) {
  const { user } = useApp();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-accent" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  return <Layout>{children}</Layout>;
}

const R = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
            <Route path="/" element={R(<Dashboard />)} />
            <Route path="/advisor" element={R(<Advisor />)} />
            <Route path="/use-cases" element={R(<UseCases />)} />
            <Route path="/sandbox" element={R(<Sandbox variant="sandbox" />)} />
            <Route path="/prompt-lab" element={R(<Sandbox variant="prompt" />)} />
            <Route path="/rag-lab" element={R(<Sandbox variant="rag" />)} />
            <Route path="/agents" element={R(<Agents />)} />
            <Route path="/models" element={R(<Models />)} />
            <Route path="/security" element={R(<Security />)} />
            <Route path="/red-team" element={R(<RedTeam />)} />
            <Route path="/ai-soc" element={R(<Soc />)} />
            <Route path="/governance" element={R(<Governance />)} />
            <Route path="/risk" element={R(<Risk />)} />
            <Route path="/compliance" element={R(<Compliance />)} />
            <Route path="/audit" element={R(<Audit />)} />
            <Route path="/maturity" element={R(<Maturity />)} />
            <Route path="/aioc" element={R(<Aioc />)} />
            <Route path="/business-value" element={R(<BusinessValue />)} />
            <Route path="/reports" element={R(<Reports />)} />
            <Route path="/integrations" element={R(<Integrations />)} />
            <Route path="/users" element={R(<Users />)} />
            <Route path="/system-admin" element={R(<SystemAdmin />)} />
            <Route path="/help" element={R(<Faq />)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
